<template>
  <div class="container">
    <div class="yield-rate-style">
      <div class="report-label">
        <p>巡查任务达成率</p>
      </div>
      <div class="condition">
        <span>请选择基地：</span>
        <a-select style="width: 120px" @change="handleChange" :value="chooseBaseName">
          <a-select-option :value="item" v-for="(item, index) in userBaseList" :key="index">
            {{ item }}
          </a-select-option>
        </a-select>
        <span style="margin-left: 3%">请选择角色：</span>
        <a-select style="width: 120px" @change="handleChangeUseRole" :value="chooseUserRole" @focus="getBaseUserRole">
          <a-select-option v-for="(item, index) in userRoleList" :key="index" :value="item.roleCode">
            {{ item.roleName }}
          </a-select-option>
        </a-select>
        <span style="margin-left: 3%">请选择统计时间区间：</span>
        <a-range-picker @change="onChange" />
        <!-- <span style="margin-left: 3%">是否隐藏100%：</span>
        <a-switch default-checked>
          <a-icon slot="checkedChildren" type="check" />
          <a-icon slot="unCheckedChildren" type="close" />
        </a-switch> -->
      </div>
      <div class="emptydiv" v-if="description">
        <a-empty style="margin-top: 10%; margin-bottom: 10%" />
      </div>
      <div class="report-view" v-if="!description">
        <a-skeleton active :loading="loadingDate" style="margin-left: 5%; width: 90%" />
        <v-chart
          :forceFit="false"
          :height="height"
          :data="data"
          :padding="padding"
          :width="1200"
          :scale="scale"
          v-if="!loadingDate"
        >
          <v-coord type="rect" direction="LB" />
          <v-tooltip :shared="true" />
          <v-axis dataKey="name" :label="label" />
          <v-interval position="name*rate" :label="labelInterval" :color="color" />
        </v-chart>
      </div>
    </div>
  </div>
</template>

<script>
import { countAchievementRate, findRoleAndBase, findInspectionRole } from '@/api/api'

const DataSet = require('@antv/data-set')

const label = { offset: 12 }

const scale = [
  {
    dataKey: 'rate',
    nice: false,
    alias: '完成率(%)',
  },
]

const labelInterval = [
  'rate',
  {
    useHtml: true,
    htmlTemplate: function htmlTemplate(text, item) {
      var a = item.point
      return '<span class="g2-label-item"><p class="g2-label-item-value" >' + a.rate + '%</p></div>'
    },
  },
]

const color = [
  'rate',
  function (val) {
    if (val <= 50) {
      return '#ff4d4f'
    } else if (val > 50 && val <= 70) {
      return '#FF8C00'
    } else if (val > 70 && val < 90) {
      return '#2194ff'
    } else {
      return '#90EE90'
    }
  },
]

export default {
  data() {
    return {
      data: [],
      height: 1200,
      label: label,
      labelInterval,
      padding: { top: 20, right: 100, bottom: 20, left: 150 },
      scale,
      color,
      chooseUserRole: '',
      chooseBaseName: '',
      startDate: '',
      endDate: '',
      userIsAdmin: false,
      userBaseList: [],
      userRoleList: [],
      description: false,
      loadingDate: false,
    }
  },
  mounted() {
    this.getUserRole()
  },
  methods: {
    handleChange(value) {
      this.chooseBaseName = value
      this.getBaseUserRole()
      this.getData()
    },
    handleChangeUseRole(value) {
      this.chooseUserRole = value
      console.log(this.chooseUserRole)
      this.getData()
    },
    onChange(date, dateString) {
      this.startDate = dateString[0]
      this.endDate = dateString[1]
      this.getData()
    },
    getBaseUserRole() {
      if (this.chooseBaseName != '' && this.chooseBaseName != null) {
        findInspectionRole(this.chooseBaseName).then((res) => {
          if (res.success) {
            this.userRoleList = res.result
            this.userRoleList.splice(0, 0, {
              roleCode: 'all',
              roleName: '全部',
            })
            if (this.userRoleList.length > 0) {
              this.chooseUserRole = res.result[0].roleCode
            }
          } else {
            this.$message.error(res.message)
          }
        })
      } else {
        this.$message.error('请先选择基地')
      }
    },
    getUserRole() {
      findRoleAndBase(this.$ls.get('Login_Userinfo').username).then((res) => {
        if (res.success) {
          this.userBaseList = res.result.baseList
          this.userIsAdmin = res.result.hasAdmin
          if (this.userBaseList.length == 1) {
            this.chooseBaseName = this.userBaseList[0]
          } else if (this.userBaseList.length > 1) {
            this.chooseBaseName = '厦门基地'
          }
          this.getBaseUserRole()
          this.getData()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getData() {
      this.loadingDate = true
      let roleCodeValue = ''
      if (this.chooseUserRole == 'all') {
        roleCodeValue = ''
      } else {
        roleCodeValue = this.chooseUserRole
      }
      let queryParam = {
        base: this.chooseBaseName,
        endDate: this.endDate,
        hasAdmin: this.userIsAdmin,
        startDate: this.startDate,
        roleCode: roleCodeValue,
        userNo: this.$ls.get('Login_Userinfo').username,
      }
      countAchievementRate(queryParam).then((res) => {
        if (res.success) {
          const sourceData = res.result
          if (res.result.length <= 0) {
            this.description = true
          } else {
            this.description = false
            let hNum = res.result.length / 4
            if (hNum < 1) {
              hNum = 1
            }
            this.height = hNum * 300
            const dv = new DataSet.View().source(sourceData)
            dv.transform({
              type: 'sort',
              callback(a, b) {
                return a.population - b.population > 0
              },
            })
            this.data = dv.rows
          }
        } else {
          this.$message.error(res.mess)
        }
        this.loadingDate = false
      })
    },
  },
}
</script>

<style scoped>
.yield-rate-style {
  background: #ffffff;
  padding-bottom: 30px;
}
.report-label {
  font-size: 18px;
  font-weight: 550;
  padding-top: 10px;
  text-align: center;
}
.condition {
  margin-left: 5%;
}
.emptydiv {
  background: #ffffff;
  text-align: center;
}
</style>
